export default "__VITE_ASSET__96qEwFOI__"